import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    selectedConsultationDate: Yup.object()
        .nullable()
        .required('Należy wskazać odpowiedni termin konsultacji'),
    selectedDoctor: Yup.object()
        .nullable()
        .required('Należy wybrać Iekarza który ma przeprowadzić konsultację'),
    importantInformation: Yup.string().required('Pole wymagane'),
    ...sharedSchema,
});
